import React from "react";
import { useTranslation } from "react-i18next";
import "../i18n";

import Layout from "../components/Layout/Layout";
import KvaliHeader from "../views/Main/KvaliHeader";
import ProudOfMember from "../views/Main/ProudOfMember/ProudOfMember";
import ApiStructure from "../views/Main/ApiStructure";
import KvaliCustomers from "../views/Main/KvaliCustomers/KvaliCustomers";
import KvaliFaq from "../views/Main/KvaliFaq/KvaliFaq";
import CaseStudies from "../views/Main/CaseStudies/CaseStudies";
import ServiceDetails from '../views/Main/ServiceDetails'

import leftGradient from "../resources/images/kvali-left-gradient.svg";
import rightGradient from "../resources/images/kvali-right-gradient.svg";




export default ({ location }) => {
  const { t } = useTranslation();

  return (
    <>
      <Layout darkColor>
        <section className="header-main light-section">
          <KvaliHeader
            headerTitle="livenessPageTitle"
            headerDescription="livenessPageDescription"
            hideLogoList
          />
          <img className="image-left-container" src={leftGradient} alt=" " />
          <img className="image-right-container" src={rightGradient} alt=" " />
        </section>
        <section>
          <KvaliCustomers />
        </section>

        <section className="light-section reset-mrg">
          <ServiceDetails data={t("livenessPageServices", { returnObjects: true })}/>
        </section>
        <section className="light-section reset-mrg">
          <ApiStructure />
        </section>
        <section className="light-section reset-mrg">
          <CaseStudies active={location.state?.active} />
        </section>
        <section className="light-section reset-mrg">
          <KvaliFaq />
        </section>
        <section className="dark-section-kvl reset-mrg">
          <ProudOfMember />
        </section>
      </Layout>
    </>
  );
};
